<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>카테고리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">컨텐츠관리</a>
        </li>
        <li class="breadcrumb-item active">카테고리관리</li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <sch-date-rage label="등록일" :data="parent"/>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="parent" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색-->

    <!-- 목록 -->
    <div class="row" v-show="parent.params.mode=='list' && child.params.mode=='list'">
      <!-- 부모카테고리 목록 -->
      <div class="col-md-6">
        <div class="card card-default">
          
          <div class="card-header">
            부모카테고리 목록
          </div>
          <div class="card-body">
            <table class="table table-striped table-bordered table-hover">
              <thead>
              <tr>
                <td @click="parentAction.sort(search,'cate_type_cd')">카테고리유형코드<em class="fa-2s mr-2 fas fa-sort"></em></td>
                <td @click="parentAction.sort(search,'cate_nm')">카테고리명<em class="fa-2s mr-2 fas fa-sort"></em></td>
                <td width="80">Action</td>
              </tr>
              </thead>
    
              <tbody>
              <tr v-show="parent.count==0" class="text-center">
                <td colspan="3">No matching records</td>
              </tr>
              <tr v-for="(item, index) in parent.list" :key="index">
                <td>{{ item.cateTypeCd }}</td>
                <td>{{ item.cateNm }}</td>
                <td>
                  <div>
                    <b-btn variant="outline-info mr-2" class="btn-xs" @click.prevent="childList(item)">detail</b-btn>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <div class="d-flex">
              <!--paging component-->
              <Pagenation :data="parent" @next="parentAction.next(search)" @prev="parentAction.prev(search)"
                          @first="parentAction.first(search)" @last="parentAction.last(search)" :key="parent.params.page"/>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 하위카테고리 목록 -->
      <div class="col-md-6">
        <div class="card card-default">

          <div class="card-header">
            하위카테고리 목록
          </div>
          <div class="card-body">
            <table class="table table-striped table-bordered table-hover">
              <thead>
              <tr>
                <td @click="childAction.sort(search,'cate_type_cd')">카테고리유형코드<em class="fa-2s mr-2 fas fa-sort"></em></td>
                <td @click="childAction.sort(search,'cate_nm')">카테고리명<em class="fa-2s mr-2 fas fa-sort"></em></td>
                <td width="80">Action</td>
              </tr>
              </thead>

              <tbody>
              <tr v-show="child.count==0" class="text-center">
                <td colspan="3">No matching records</td>
              </tr>
              <tr v-for="(item, index) in child.list" :key="index">
                <td>{{ item.cateTypeCd }}</td>
                <td>{{ item.cateNm }}</td>
                <td>
                  <div>
                    <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="edit(item)"><em class="fa fa-search"></em></b-btn>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <div class="d-flex">
              <!--paging component-->
              <Pagenation :data="child" @next="childAction.next(search)" @prev="childAction.prev(search)"
                          @first="childAction.first(search)" @last="childAction.last(search)" :key="child.params.page"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
    <div v-show="child.params.mode=='detail'" class="card card-default">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <form data-vv-scope="edit">
          <input type="hidden" v-model="parent.row.adminSeq"/>
          <table class="table table-bordered">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>

            <tr>
              <th>부모카테고리번호</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.pCateSeq')}"
                       v-model="parent.row.pCateSeq" placeholder="pCateSeq" v-validate="''" name="pCateSeq"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.pCateSeq')" class="invalid-feedback">{{
                    errors.first('edit.pCateSeq')
                  }}</span>
              </td>
              <th>카테고리유형코드</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.cateTypeCd')}"
                       v-model="parent.row.cateTypeCd" placeholder="cateTypeCd" v-validate="''" name="cateTypeCd"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.cateTypeCd')" class="invalid-feedback">{{
                    errors.first('edit.cateTypeCd')
                  }}</span>
              </td>
            </tr>
            <tr>
              <th>카테고리명</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.cateNm')}"
                       v-model="parent.row.cateNm" placeholder="cateNm" v-validate="''" name="cateNm"
                       style="width: 200px"/>
                <span v-show="errors.has('edit.cateNm')" class="invalid-feedback">{{
                    errors.first('edit.cateNm')
                  }}</span>
              </td>
              <th>링크정보</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.link')}"
                       v-model="parent.row.link" placeholder="link" v-validate="''" name="link" style="width: 200px"/>
                <span v-show="errors.has('edit.link')" class="invalid-feedback">{{ errors.first('edit.link') }}</span>
              </td>
            </tr>
            <tr>
              <th>정렬순서</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.sort')}"
                       v-model="parent.row.sort" placeholder="sort" v-validate="''" name="sort" style="width: 200px"/>
                <span v-show="errors.has('edit.sort')" class="invalid-feedback">{{ errors.first('edit.sort') }}</span>
              </td>
              <th>여유필드1</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.val1')}"
                       v-model="parent.row.val1" placeholder="val1" v-validate="''" name="val1" style="width: 200px"/>
                <span v-show="errors.has('edit.val1')" class="invalid-feedback">{{ errors.first('edit.val1') }}</span>
              </td>
            </tr>
            <tr>
              <th>여유필드2</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.val2')}"
                       v-model="parent.row.val2" placeholder="val2" v-validate="''" name="val2" style="width: 200px"/>
                <span v-show="errors.has('edit.val2')" class="invalid-feedback">{{ errors.first('edit.val2') }}</span>
              </td>
              <th>삭제여부</th>
              <td>
                <b-input-group>
                  <div>
                    <div class="form-check mb-2">
                      <input class="form-check-input" id='form-check-delYn' v-model="parent.row.delYn" true-value="Y"
                             false-value="N" type="checkbox"/>
                      <label class="form-check-label" for='form-check-delYn'>{{
                          parent.row.delYn == 'Y' ? '삭제' : '전시'
                        }}</label>
                    </div>
                  </div>
                </b-input-group>
              </td>
            </tr>
            <tr>
              <th>등록자ID</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.regId')}"
                       v-model="parent.row.regId" placeholder="regId" v-validate="''" name="regId" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.regId')" class="invalid-feedback">{{ errors.first('edit.regId') }}</span>
              </td>
              <th>등록일시</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.regDt')}"
                       v-model="parent.row.regDt" placeholder="regDt" v-validate="''" name="regDt" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.regDt')" class="invalid-feedback">{{ errors.first('edit.regDt') }}</span>
              </td>
            </tr>
            <tr>
              <th>수정자ID</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.updId')}"
                       v-model="parent.row.updId" placeholder="updId" v-validate="''" name="updId" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.updId')" class="invalid-feedback">{{ errors.first('edit.updId') }}</span>
              </td>
              <th>수정일시</th>
              <td>
                <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.updDt')}"
                       v-model="parent.row.updDt" placeholder="updDt" v-validate="''" name="updDt" style="width: 200px"
                       readonly/>
                <span v-show="errors.has('edit.updDt')" class="invalid-feedback">{{ errors.first('edit.updDt') }}</span>
              </td>
            </tr>

          </table>
        </form>
      </div>

      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="save()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">저장</b-button>
          <b-button @click="remove()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">삭제</b-button>
          <b-button @click="search()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->

  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsCateList, getCsCateItem, saveCsCate, deleteCsCate} from "@/api/cs/CsCateApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject} from "@/utils/Constants";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";

export default {
  components: {SchDateRange, SchText, Pagenation},
  setup() {
    const schOptions = [{value: 'name', text: '이름'}, {value: 'admin_id', text: 'ID'}]
    const _dataObject = _.cloneDeep(dataObject);
    const parent = reactive(_dataObject)
    parent.schOptions = schOptions // 검색 type 선택

    const _dataObject2 = _.cloneDeep(dataObject);
    const child = reactive(_dataObject2)
    console.log('$$ child', child)

    const loadData = async () => {
      let result = await getCsCateList(parent.params);
      parent.list = result.data;
      parent.count = result.count;
    }
    onMounted(loadData)

    return {
      parent,
      child,
      ...methods(),
      parentAction: new TableActionClass(parent),
      childAction: new TableActionClass(child)
    }
  },
}

function methods() {
  var context = {};
  context["getCsCateList"] = getCsCateList;  // get list
  context["getCsCateItem"] = getCsCateItem;  // get item
  context["deleteCsCate"] = deleteCsCate;  // delete item
  context["saveCsCate"] = saveCsCate;  // save item

 // 목록
  async function search() {
    let _params = this.parent.params
    this.parentAction.execute("getCsCateList", context, _params);
  }

  // 하위코드목록
  async function childList(_params) {
    let _childParam = this.child.params
    if (_params) {
      _childParam.pCateSeq = _params.cateSeq;
    }
    this.childAction.execute("getCsCateList", context, _childParam);
  }

  // 상세
  async function edit(_params) {
    _params = !_params ? this.parent.row : _params
    await this.childAction.execute("getCsCateItem", context, _params);
  }

  // 삭제
  async function remove(_params) {
    _params = !_params ? this.parent.row : _params
    await this.childAction.execute("deleteCsCate", context, _params);
    this.search();
  }

  // 저장
  async function save() {
    const validForm = await this.$validator.validateAll('edit').then((result) => {
      return result;
    });
    if (validForm) {
      let _params = this.parent.row
      await this.childAction.execute("saveCsCate", context, _params);
      this.search();
    }
  }

  // 초기화
  async function reset() {
    this.childAction.clear();
  }

  return {reset, search, edit, save, remove, childList}
}


</script>